import React from 'react';
import PropTypes from 'prop-types';
import BaseNext from './base-next';

const phoneMask = [
  '(',
  /[1-9]/,
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/
];

const PhoneNumberNext = props => {
  const { onChange, value, error, touched, onBlur, isDisabled } = props;
  return (
    <BaseNext
      isDisabled={isDisabled}
      data-cv-test="phoneNumber"
      labelText="Mobile Number"
      onChange={onChange}
      error={error}
      id="phone"
      type="tel"
      touched={touched}
      value={value}
      textMask={phoneMask}
      onBlur={onBlur}
    />
  );
};

PhoneNumberNext.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string.isRequired,
  touched: PropTypes.bool,
  isDisabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};

PhoneNumberNext.defaultProps = {
  error: false,
  touched: false,
  isDisabled: false,
  onChange: () => {},
  onBlur: () => {}
};

export default PhoneNumberNext;
